import React, { Component } from 'react';
// import { withStyles } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Slide, Typography } from '@mui/material';

import AppBindStyles from "../../AppBindStyles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const smallDeviceSize = 890;

class PaymentSourceDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      smallDevice: (window.innerWidth < smallDeviceSize)
    };
 
    // .bind() creates a NEW instance of the target function
    // store this instance in a variable and use in componentDidMount() and componentWillUnmount()
    this.onResizeBound = this.onResize.bind(this);
    // if you code it this way:
    //  window.addEventListener('resize', this._onResize.bind(this));
    //  window.removeEventListener('resize', this._onResize.bind(this));
    // this is wrong! as mentioned above .bind() creates a NEW instance of the target function
    // therefore the removeEventListener() is not removing the original reference on the addEventListener()
    // and the event and handler function is executing on other pages
  }

  componentDidMount() {
    
    window.addEventListener('resize', this.onResizeBound);
  }

  componentWillUnmount() {
    
    window.removeEventListener('resize', this.onResizeBound);
  }

  onResize() {
    //console.log( 'small=' + this.state.smallDevice + ', width=' + window.innerWidth );
    if( this.state.smallDevice && window.innerWidth >= smallDeviceSize ) {
      this.setState({smallDevice: false});

    } else if ( !this.state.smallDevice && window.innerWidth < smallDeviceSize ) {
      this.setState({smallDevice: true});
    }
  }


    handleClose = (event) => {
        this.props.onClose(event);
    };
    
    render() {
        
        return (
          <Dialog 
                fullScreen
                maxWidth={false}
                open={this.props.open}
                onClose={this.props.onClose}
                TransitionComponent={Transition} >
            {((!this.props.noClose) || (this.props.noClose === false)) &&
            <Typography>
              <IconButton size="small"
                  style={{float:'right', margin: '5px'}} onClick={this.handleClose}
                ><Close/></IconButton>
            </Typography>
            }
            <DialogContent style={{textAlign:'center'}}>
              <div style={{width: '100%'}}>
                {this.state.smallDevice &&
                  <div style={{margin: 'auto'}}>
                    <DialogTitle style={AppBindStyles.fullScreenDialogTitle}>{this.props.title}</DialogTitle>
                    {this.props.children}
                  </div>
                }
                {!this.state.smallDevice &&
                  <div style={{width:'800px',margin: 'auto'}}>
                    <DialogTitle style={AppBindStyles.fullScreenDialogTitle}>{this.props.title}</DialogTitle>
                    {this.props.children}
                  </div>
                }
              </div>
            </DialogContent>
          </Dialog>
        );
    }
}
  
export default PaymentSourceDialog;